'use strict';

angular.module('shiftTraderApp')
    .directive('saDaysOffCalendarDay', function () {
      return {
        templateUrl: 'views/daysOff/saDaysOffCalendarDay.html',
        restrict: 'A',
        scope: {
          focusFn: '&',
          day: '=saDaysOffCalendarDay'
        },
        link: function(scope, elem) {
          scope.focusOnDayOff = function(arg) {
            return scope.focusFn()(arg);
          };

        }
      };
    });
